module.exports = __webpack_public_path__ + "img/004.2e95f521.jpg";